import { Formik, Form, Field } from "formik";
import React, { useState } from "react";
import { useDispatch } from "react-redux";

import FieldErrorMessage from "@/Components/common/FieldErrorMessage";
import { RequiredSymbol } from "@/Components/common/RequiredSymbol";
import { updateNewUser, updateShowBoxes } from "@/reducers/auth";
import { _forgotPassword } from "@/services/auth";
import { handleAPICatch, showSuccessToast } from "@/utilities/utils";
import { validateEmail } from "@/validations/auth/login";

import AuthButton from "../AuthButton";
import LoginFormTopContent from "../LoginFormTopContent";

/**
 * Function for handling the forgot password form submission.
 *
 * @param {object} authEmail - the email address for authentication
 * @param {function} setAuthEmail - a function to update the authentication email
 * @return {void} This function does not return any value
 */
const ForgotPasswordForm = ({ authEmail, setAuthEmail }) => {
  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmitEmail = (values, { setSubmitting }) => {
    if (isSubmitting) {
      return;
    }
    setIsSubmitting(true);
    setSubmitting(true);
    let response = _forgotPassword(values);
    response
      .then((res) => {
        // setAuthEmail("");
        let {
          status: resStatus,
          data: { user, message },
        } = res;
        let { user_id, user_type } = user;
        if (resStatus == 200) {
          dispatch(
            updateNewUser({
              id: user_id,
              type: user_type,
              email: values.email,
            }),
          );
          dispatch(updateShowBoxes("verification_code"));
          showSuccessToast(message);
        } else {
          showSuccessToast(message);
        }
      })
      .catch((error) => {
        handleAPICatch(error);
      })
      .finally(() => {
        setSubmitting(false);
        setIsSubmitting(false);
      });
  };
  return (
    <div className="auth_form_wrapper">
      <Formik
        initialValues={{
          email: authEmail,
        }}
        enableReinitialize={true}
        validateOnChange={false}
        validateOnBlur={false}
        validateOnMount={false}
        onSubmit={(values, { setSubmitting }) => {
          handleSubmitEmail(values, { setSubmitting });
        }}
      >
        {({
          submitForm,
          isSubmitting,
          errors,
          touched,
          isValid,
          setSubmitting,
        }) => (
          <Form className="flex flex-col gap-6">
            <LoginFormTopContent
              title="Forgot Password"
              desc="We will send you an email with further instruction to reset your password."
            />
            <div>
              <div className="grid gap-4">
                <div className="flex flex-col gap-3">
                  <label htmlFor="email" className="label text-[14px]">
                    Email <RequiredSymbol />
                  </label>
                  <div>
                    <Field
                      type="email"
                      className={`h-[40px] w-full rounded-lg border border-bodyText bg-none text-[14px] text-black shadow-none placeholder:text-[14px] placeholder:font-medium placeholder:text-txtColor autofill:bg-none autofill:shadow-none focus:border focus:border-primary focus:shadow-none focus:ring-0 ${
                        errors.email && touched.email ? "!border-red-500" : ""
                      }`}
                      autoComplete="off"
                      name="email"
                      placeholder="Email Address"
                      validate={(value) => validateEmail(value)}
                      onChange={(e) => {
                        setAuthEmail(e.target.value);
                      }}
                      onKeyUp={(e) => {
                        if (e.keyCode === 13) {
                          submitForm();
                          if (document.activeElement != document.body)
                            document.activeElement.blur();
                        }
                      }}
                      value={authEmail}
                    />
                    <FieldErrorMessage name="email" />
                  </div>
                </div>
              </div>
              <AuthButton
                submitForm={submitForm}
                isSubmitting={isSubmitting}
                isValid={isValid}
                btnText={"Send"}
                btnLoadingText={"Sending"}
                disabled={isSubmitting}
              />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default ForgotPasswordForm;
